import React from 'react';
import { Target, KeySquare, Palette, Sparkles } from 'lucide-react';

const steps = [
  {
    icon: Target,
    title: 'Choose Your Sport',
    description: 'Select from football, basketball, soccer, baseball, hockey, and more.'
  },
  {
    icon: KeySquare,
    title: 'Select Team Level',
    description: 'Pick from professional, amateur, youth, or college team options.'
  },
  {
    icon: Palette,
    title: 'Add Keywords',
    description: 'Customize with specific terms that represent your team\'s identity.'
  },
  {
    icon: Sparkles,
    title: 'Generate Names',
    description: 'Get instant, sport-specific team name suggestions.'
  }
];

export default function SportsTeamHowItWorks() {
  return (
    <section className="py-20 bg-indigo-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          How Our Sports Team Name Generator Works
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-1/2 w-full h-0.5 bg-indigo-200 transform -translate-y-1/2">
                  <div className="absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2">
                    <div className="w-3 h-3 bg-indigo-200 rotate-45 transform origin-center"></div>
                  </div>
                </div>
              )}
              <div className="relative text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-indigo-100 mb-4 transform transition-transform hover:scale-110">
                  <step.icon className="w-8 h-8 text-indigo-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white p-8 rounded-xl shadow-lg max-w-3xl mx-auto">
          <h3 className="text-2xl font-semibold text-center text-gray-900 mb-6">
            Advanced AI Name Generation
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <h4 className="font-semibold text-indigo-600">What We Consider:</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
                  <span>Sport-specific terminology</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
                  <span>Team level appropriateness</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
                  <span>Local relevance</span>
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h4 className="font-semibold text-indigo-600">Name Qualities:</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
                  <span>Memorable and unique</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
                  <span>Easy to chant</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
                  <span>Team spirit building</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}